import Vue from 'vue';

const success = (context, response, fromBookings) => {
  context.success = response.data.msg;
  context.message.text = '';
  context.messagesLoading = false;
  if(fromBookings) {
    context.messages.push(response.data.message);
    context.reminderTime = "";
    context.customDateSelected = "";
  }else {
    context.threads[context.activeThread].messages.push(response.data.message);
    setTimeout(function() {
      let container = context.$refs.messages;
      container.scrollTop = container.scrollHeight;
    }, 500);
  }
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.messagesLoading = false;
};

export default (context, message, fromBookings = false) => {
  return Vue.$http.post("messages/save-reminder", message)
    .then(response => {
      if(response.status === 200) {
        success(context, response, fromBookings);
      }
    }).catch(error => {
      failed(context, error);
    });
}



// WEBPACK FOOTER //
// ./src/app/services/message/saveReminder.js